import React from 'react'
import EkycSellingChannel from 'e-submission/components/Card/EkycSellingChannel'

const withHoc = (hoc) => {
  const WrappedComponent = (props) => {
    return <EkycSellingChannel {...props} />
  }

  return hoc(WrappedComponent)
}

export default withHoc
